import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ButtonData {
  color: string;
  title: string;
  url: string;
  page: string;
  butttonBackgroundColor: string;
  buttonBorderColor: string;
  buttonTextColor: string;
  active: any;
}

@Component({
  selector: 'fcp-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent {
  @Input() public buttons: Array<ButtonData>;
  @Input() public matMenuTriggerFor: any;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();

  public active = false;

  public emitClick(button: any): void {
    if (button) {
      this.wasClicked.emit(button);
    }
  }
}
